
document.addEventListener('DOMContentLoaded', () => {
  const priceEl = document.querySelector('[data-product-price]');
  const sticky = document.querySelector('[data-sticky-atc]');
  if (priceEl && sticky) {
    sticky.style.display = 'block';
    sticky.innerHTML = `<div class="container" style="display:flex;justify-content:space-between;align-items:center;gap:.75rem">
      <div><span class="badge">In stock</span></div>
      <div style="display:flex;gap:.6rem;align-items:center"><strong class="price">${priceEl.textContent}</strong>
      <a href="#buy" class="btn primary">Add to cart</a></div></div>`;
  }
});


// Intercept any Add-to-Cart attempt and redirect to 404 with a message
document.addEventListener('submit', (e) => {
  const form = e.target;
  try {
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.includes('/cart/add')) {
      e.preventDefault();
      window.location.href = '/404?cart=disabled';
    }
  } catch(_) {}
});
